// Actions
export const FETCH_APP_INFO_SUCCESS = 'FETCH_APP_INFO_SUCCESS';

// Reducer
export default function appInfoReducer(state = { 'LOGIN_REDIRECT_URL': null }, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_APP_INFO_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchAppInfoSuccess(payload) {
  return { type: FETCH_APP_INFO_SUCCESS, payload };
}



// WEBPACK FOOTER //
// ./src/redux/modules/appInfo.js